import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("ellipse", {
  cx: "12",
  cy: "5",
  rx: "9",
  ry: "3"
}), ___EmotionJSX("path", {
  d: "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
}), ___EmotionJSX("path", {
  d: "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
}));
export default SVG;